// AI-CONTEXT: See docs/patterns.md#dashboard-static-card
// AI-CONTEXT: See docs/pitfalls.md#ui-empty-state-claims-absence-while-loading
import LoadingSpinner from '../common/LoadingSpinner'

/**
 * De waarderegel van een KPI/trend-tegel, met de drie toestanden uit elkaar
 * gehouden:
 *
 *   laden  → laadindicator. Een streepje is een bewering aan de lezer ("er is
 *            geen waarde") en die is onwaar zolang de gegevens onderweg zijn.
 *   null   → streepje. Er is vastgesteld dat er niets te tonen valt.
 *   waarde → het getal zelf.
 *
 * Eén component voor alle tegels in de KPI-rij, zodat die drie takken niet in
 * vijf kaarten uiteen gaan lopen.
 * AI-CONTEXT: See docs/pitfalls.md#dev-copied-recipe-instead-of-shared-hook
 *
 * Laden wint van een aanwezige waarde: bij een verversing hoort de lezer te
 * zien dat er een nieuw getal aankomt, niet een oud getal dat stil blijft staan.
 *
 * @param {object} props
 * @param {boolean} props.loading - Staan de gegevens nog onderweg?
 * @param {string|number|null} props.value - De te tonen waarde; null betekent 'niets te tonen'
 * @param {string} [props.valueClassName] - Extra class(es) op de waarderegel, bijv. een kleurband
 * @param {() => void} [props.onClick] - Maakt de waarde een knop (bijv. naar een verloop over de tijd).
 *   Alleen bij een echte waarde: een streepje of laadindicator heeft niets om naar door te klikken.
 * @param {string} [props.ariaLabel] - Naam van die knop; verplicht zodra `onClick` er is
 */
const KpiValue = ({ loading, value, valueClassName = '', onClick, ariaLabel }) => {
    if (loading) {
        return <LoadingSpinner className='loading-spinner--inline participation-value-spinner' />
    }

    if (value === null || value === undefined) {
        return (
            <p className='participation-value-amount participation-value-amount--placeholder'>—</p>
        )
    }

    // Een <button> en niet een klikbare <p>: die is met het toetsenbord niet
    // te bereiken. En niet een <p> ín een knop — dat is ongeldige HTML.
    // AI-CONTEXT: See docs/pitfalls.md#ui-heading-inside-button-stops-being-a-heading
    if (onClick) {
        return (
            <button
                type='button'
                className={`participation-value-amount participation-value-amount--link ${valueClassName}`.trim()}
                // Het bedrag hoort in de naam: alleen 'Omzet over de tijd'
                // laat een schermlezer het getal zelf overslaan.
                aria-label={`${value} — ${ariaLabel}`}
                onClick={onClick}
            >
                {value}
            </button>
        )
    }

    return (
        <p className={`participation-value-amount ${valueClassName}`.trim()}>{value}</p>
    )
}

export default KpiValue
